var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 345.1 345.1",
    style: {
      enableBackground: "new 0 0 345.1 345.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2D243;}\n\t.st1{fill:#975C1A;}\n\t.st2{fill:#FAF7F7;}\n\t.st3{fill:none;stroke:#794A12;stroke-width:4.58;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#80C0EA;}\n\t.st5{fill:#794A12;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 172.3,
    cy: 172.3,
    r: 172.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 172.3,
    cy: 248.7,
    rx: 35.9,
    ry: 44.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.8,242.1c23.7,0.1,47.4,0.2,71,0.3c-0.1-20.5-15.1-37.2-33.1-38.5C155.2,202.5,137.2,219.7,136.8,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.2,248.7c0,24.8-16.1,44.9-35.9,44.9c-19.8,0-35.9-20.1-35.9-44.9s16.1-44.9,35.9-44.9 C192.2,203.8,208.2,223.9,208.2,248.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.5,139.8c0.2,65,0.4,130.1,0.6,195.1c16.5-5.9,31.9-14.1,45.6-24.5c0.2-53.3,0.3-106.5,0.5-159.8 c-4.6-3-12.1-7.2-22.3-9.6C243.7,138.7,235,139.1,229.5,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.7,141.1c-10.2,2.4-17.7,6.6-22.3,9.6c0.2,53.3,0.3,106.5,0.5,159.8c13.8,10.3,29.1,18.6,45.6,24.5 c0.2-65,0.4-130,0.6-195.1C109.7,139.1,100.9,138.7,90.7,141.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.1,158.6c-14.2-9.6-30.1-15.7-47.1-15.8c-17-0.3-33,5.4-47.5,14.6c5.5-6.9,12.9-12.4,21.1-16.1 C105.3,129.7,137.6,136.8,154.1,158.6L154.1,158.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.9,104.6c-11.4,0-22.5,2.6-31.9,8.8c-9.5,6.2-16.2,15.3-20.7,25.8c0.4-5.9,2.5-11.6,5.6-16.8 C69.1,106.9,89.6,98.8,106.9,104.6L106.9,104.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.5,158.6c16.5-21.8,48.8-28.9,73.5-17.3c8.2,3.8,15.6,9.2,21.1,16.1c-14.4-9.2-30.4-14.9-47.5-14.6 C220.6,142.9,204.7,149.1,190.5,158.6L190.5,158.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.8,104.6c17.2-5.9,37.8,2.3,47,17.9c3.1,5.1,5.2,10.9,5.6,16.8c-4.5-10.5-11.2-19.6-20.7-25.8 C260.2,107.2,249.2,104.6,237.8,104.6L237.8,104.6z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrying);
export default __webpack_public_path__ + "static/media/crying.56843d29e1c872054e6ac388e8b63d58.svg";
export { ForwardRef as ReactComponent };